var ECaptchaType;

(function (ECaptchaType) {
  ECaptchaType["Geetest"] = "geetest";
  ECaptchaType["NoCaptcha"] = "nocaptcha";
})(ECaptchaType || (ECaptchaType = {}));

var ECaptchaErrorType;

(function (ECaptchaErrorType) {
  /** /captcha/challenge 接口报错 */
  ECaptchaErrorType["CaptchaChallengeApiError"] = "CaptchaChallengeApiError";
  /** 加载 gt.js 失败 */

  ECaptchaErrorType["GeetestLoadingError"] = "GeetestLoadingError";
  /** window 上不存在 initGeetest */

  ECaptchaErrorType["GeetestInitError"] = "GeetestInitError";
  /** geetest 验证报错 */

  ECaptchaErrorType["GeetestVerifyError"] = "GeetestVerifyError";
  /** 初始时发生未知错误 */

  ECaptchaErrorType["InitUnknownError"] = "InitUnknownError";
  /** window 上不存在 noCaptcha */

  ECaptchaErrorType["NoCaptchaInitError"] = "NoCaptchaInitError";
  /** window 上不存在 NoCaptcha */

  ECaptchaErrorType["NoCaptchaH5InitError"] = "NoCaptchaH5InitError";
  /** 加载 nc.js 失败 */

  ECaptchaErrorType["NoCaptchaLoadingError"] = "NoCaptchaLoadingError";
})(ECaptchaErrorType || (ECaptchaErrorType = {}));

export { ECaptchaErrorType, ECaptchaType };
